import { useTranslation } from 'react-i18next'
import { Doughnut } from 'react-chartjs-2'
import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useSelector } from 'react-redux'
import ChartDataLabels from 'chartjs-plugin-datalabels'

import GraphContainer from '../GraphContainer'

import { getOptions } from './getOptions'
import { getHtmlLegendPlugin } from '../../../plugins'
import { formatNumberToShort } from '../../../helpers'

import { socialReturnOnInvestmentReportSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'

import useStyles from './styles'

const GenderGraph = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  const { femalePercentage, malePercentage, unknownGenderPercentage, stakeholderCount } = useSelector(
    socialReturnOnInvestmentReportSelector
  )

  const graphData = useMemo(
    () => ({
      labels: ['Female', 'Male', 'Unknown'],
      datasets: [
        {
          label: 'Gender',
          data: [femalePercentage, malePercentage, unknownGenderPercentage],
          backgroundColor: ['#4A3AFF', '#962DFF', '#C6D2FD'],
          borderRadius: 18
        }
      ]
    }),
    [femalePercentage, malePercentage, unknownGenderPercentage]
  )

  const legendContainerId = useMemo(() => uuidv4(), [])

  const options = useMemo(() => getOptions(legendContainerId), [legendContainerId])

  const plugins = useMemo(() => {
    const htmlLegendPlugin = getHtmlLegendPlugin()

    return [htmlLegendPlugin, ChartDataLabels]
  }, [])

  const formattedStakeholderCount = useMemo(() => {
    return formatNumberToShort(stakeholderCount)
  }, [stakeholderCount])

  return (
    <GraphContainer
      title={t('Gender')}
      totalValue={formattedStakeholderCount}
      totalValueDescription="beneficiaries"
      className={classes.genderGraphContainer}
    >
      <div className={classes.graphWrapper}>
        <div className={classes.legendContainer} id={legendContainerId}>
          {/*// The legend of the graph will be rendered here by the plugin*/}
        </div>
        <div>
          <Doughnut data={graphData} options={options} plugins={plugins} />
        </div>
      </div>
    </GraphContainer>
  )
}

export default GenderGraph
